<template>
<div class="vertical_center">
<div class=" p-4 shadow-2 border-round w-full ">
    <div class="text-center mb-5">
        
        <div class="text-900 text-3xl font-medium mb-3">{{$store.state.languages.lang_phrases.email_adresinizi_girin}}</div>
        <!--<span class="text-600 font-medium line-height-3">Don't have an account?</span>
        <a class="font-medium no-underline ml-2 text-blue-500 cursor-pointer">Create today!</a>-->
    </div>

    <div>
        

        

     <span class="p-float-label mb-5">
        <InputText id="email" type="email" v-model="email" class="w-full p-inputtext-lg"  :class="{'p-invalid':errors.passerror }" v-on:keyup.enter="submit"/>
        <label for="email">Email</label>
        
      </span>

      <span v-if="showerror" class="flex align-items-center justify-content-between mb-6">

       <small class="p-error">This email address is not valid</small>
      </span>

        <Button :label="$store.state.languages.lang_phrases.sifirlama_linki_yolla" icon="pi pi-user" class="w-full p-button-primary" :loading="$store.state.ui.submitting" @click="submit"></Button>
        
         <div class="flex align-items-center justify-content-end mt-6">           
            <router-link to="/login" class="font-medium no-underline ml-2 text-blue-500 text-right cursor-pointer">{{$store.state.languages.lang_phrases.ya_da_giris_yapin}}</router-link>
        </div>
    </div>
</div>
</div>


</template>

<script>
export default {

  name: 'SendResetLink',

  data () {
    return {
      checked:false,
      email:null,  
      showerror:false,   
      errors:{
        passerror:false,
        passerror_message:null,
        repasserror:false,
        repasserror_message:null
      }
    }
  },
  methods:{
    submit()
    {
     this.showerror = false
      let formdata = new FormData()
      formdata.append("email",this.email)
      this.generalSubmission(formdata,"send_reset_password",this.afterSubmit)
    },
    afterSubmit(response)
    {

      //console.log(response.data);
      if(response.data=="ok")
      {
        this.$router.push({ name: 'Login'})
      }
      if(response.data=="not ok")
      {
        this.showerror = true
      }
    }
  }
};
</script>

<style lang="css" scoped>
</style>